<template lang="pug">
  v-tooltip(bottom)
    template(v-slot:activator="{on}")
      v-icon(:small="small" :large="large" v-on:click="onClick" v-on="on" :color="color") {{ icon }}
    span
      slot
</template>

<script>
export default {
  name: 'ToolTipIcon',
  props: {
    icon: String,
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
